var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoFuncaoMultiplicacao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-funcao-multiplicacao",
    transform: "translate(-335 -870)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2190",
    "data-name": "Grupo 2190"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2189",
    "data-name": "Grupo 2189"
  }, /*#__PURE__*/React.createElement("g", {
    id: "multiplica\\xE7\\xE3o",
    transform: "translate(173.688 706.205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "multiplication",
    transform: "translate(166.312 168.794)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1259",
    "data-name": "Grupo 1259",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1258",
    "data-name": "Grupo 1258",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_745",
    "data-name": "Caminho 745",
    d: "M50.255,0H2.185a2.185,2.185,0,1,0,0,4.37h48.07a2.185,2.185,0,0,0,0-4.37Z",
    transform: "translate(3.09 0) rotate(45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_748",
    "data-name": "Caminho 748",
    d: "M50.253,4.37l-48.069,0a2.185,2.185,0,1,1,0-4.37L50.253,0a2.185,2.185,0,0,1,0,4.37Z",
    transform: "translate(40.171 3.091) rotate(135)"
  }))))), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_442",
    "data-name": "Ret\\xE2ngulo 442",
    width: 50,
    height: 50,
    transform: "translate(335 870)",
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFuncaoMultiplicacao);
export default __webpack_public_path__ + "static/media/ico-funcao-multiplicacao.1d441f6ae295f33332ffd933ea89631c.svg";
export { ForwardRef as ReactComponent };